(() => {
  const container = document.querySelector('.rb-giveaway__form');
  if (!container) return;
  const css = `
    :host { --forms-base-font-size:16px; --forms-body-font:normal 400 16px Arial,sans-serif; --forms-base-font-line-height:1.6; --container-text-alignment:left; --form-text-color:#080808; --form-placeholder-color:#454545; }
    #app-embed :is(p,legend,span) { line-height:1.6; }
    #app-embed [data-testid="form"] + div { color:#fff; font-size:14px; line-height:1.65; text-align:left; }
    #app-embed [data-testid="form"] + div :is(p,a) { font-size:inherit; line-height:inherit; color:inherit; }
    #app-embed input:not([type="checkbox"]):not([type="radio"]) { font-size:16px; color:#080808; background:#fff; }
    #app-embed div:has(> input[data-testid="field-email"]) { display:flex; flex-direction:column; align-items:stretch; }
    #app-embed label[for="email"] { position:static !important; inset:auto !important; transform:none !important; translate:none !important; order:-1; display:block; margin:0 0 8px; padding:0; font-size:16px !important; line-height:1.4 !important; color:#fff !important; opacity:1 !important; background:transparent; pointer-events:auto; }
    #app-embed input[data-testid="field-email"] { box-sizing:border-box; width:100%; min-width:0; margin:0; min-height:56px; padding:14px 16px !important; line-height:1.4; }
    #app-embed button[type="submit"] { box-sizing:border-box; display:flex; align-items:center; justify-content:center; align-self:stretch; width:100%; min-width:0; min-height:56px; height:auto; margin:0; padding:16px !important; font-size:16px; line-height:1.4; font-weight:700; text-align:center; white-space:normal; color:#080808; background:#c6b38e; }
    #app-embed input[data-testid="field-email"]:focus-visible { outline:2px solid #c6b38e; outline-offset:2px; }
    #app-embed :is(button,a):focus-visible { outline:3px solid #c6b38e; outline-offset:3px; }
  `;
  let connected = false;
  const apply = () => {
    const host = container.querySelector('shopify-forms-embed');
    const root = host?.shadowRoot;
    if (!root) return;
    if (!root.querySelector('style[data-rb-readable]')) {
      const style = document.createElement('style');
      style.dataset.rbReadable = '';
      style.textContent = css;
      root.append(style);
    }
    if (!connected) {
      connected = true;
      new MutationObserver(apply).observe(root, {childList:true});
    }
  };
  new MutationObserver(apply).observe(container, {childList:true,subtree:true});
  customElements.whenDefined('shopify-forms-embed').then(apply);
  apply();
})();

